import { render } from "./ProjectTabContract.vue?vue&type=template&id=4a23e489&scoped=true&ts=true"
import script from "./ProjectTabContract.vue?vue&type=script&lang=ts"
export * from "./ProjectTabContract.vue?vue&type=script&lang=ts"

import "./ProjectTabContract.vue?vue&type=style&index=0&id=4a23e489&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a23e489"]])

export default __exports__